<template>
  <div>
    <common-title :title="'会议详情'"></common-title>
    <div class="outdiv">
      <el-form :model="meetingForm" ref="meetingForm" label-width="190px">
        <el-form-item
            label="语言版本:"
        >
          <label v-if="meetingForm.languageType==LanguageTypeEnum.zh" :label="0">中文</label>
          <label v-if="meetingForm.languageType==LanguageTypeEnum.en" :label="1">英文</label>
          <label v-if="meetingForm.languageType==LanguageTypeEnum.zhen" :label="2">中文/英文</label>
        </el-form-item>
        <el-form-item label="会议标题:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.meetingSubject }}</label>
        </el-form-item>
        <el-form-item label="会议标题（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.meetingSubjectEn }}</label>
        </el-form-item>
        <el-form-item label="主办单位:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.organizer }}</label>
        </el-form-item>
        <el-form-item label="主办单位（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.organizerEn }}</label>
        </el-form-item>
        <el-form-item label="承办单位:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.undertaker }}</label>
        </el-form-item>
        <el-form-item label="承办单位（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.undertakerEn }}</label>
        </el-form-item>
        <el-form-item label="举办地址:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.address }}</label>
        </el-form-item>
        <el-form-item label="举办地址（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.addressEn }}</label>
        </el-form-item>
        <el-form-item label="会议时间:">
          <label>{{ meetingForm.startTime }}</label><label v-if="meetingForm.endTime"> - {{ meetingForm.endTime }}</label>
        </el-form-item>
        <el-form-item label="会议时间文本:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.meetingStartTime }}</label>
        </el-form-item>
        <el-form-item label="会议时间文本（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.meetingStartTimeEn }}</label>
        </el-form-item>
        <el-form-item label="投稿结束时间:">
           <label>{{ meetingForm.contributionDeadline }}</label>
        </el-form-item>
        <el-form-item label="投稿结束时间文本:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
           <label>{{ meetingForm.meetingContributionTime }}</label>
        </el-form-item>
        <el-form-item label="投稿结束时间文本（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
           <label>{{ meetingForm.meetingContributionTimeEn }}</label>
        </el-form-item>
        <el-form-item label="会议介绍:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <pre v-html="meetingForm.meetingIntroduce"></pre>
        </el-form-item>
        <el-form-item label="会议介绍（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <pre v-html="meetingForm.meetingIntroduceEn" ></pre>
        </el-form-item>
        <el-form-item label="征文主题:">
          <div class="tagMaxHeight">
            <p v-for="(item, index) in meetingForm.crSolicitcInfoEntityVoList" :key="index">
              {{index+1}}.
              {{
                item.solicitcName
              }}</p>
          </div>
        </el-form-item>
        <el-form-item label="双重提交:">
          <span>{{meetingForm.doubleSubmissionOrNot==1?'是':'否'}}</span>
          <div class="tagMaxHeight">
            <p v-if="meetingForm.doubleSubmissionOrNot==1" v-for="(item, index) in meetingForm.crSubmissionEntityList" :key="index">
              {{index+1}}.
              {{
                item.doubleSubmissionComment
              }}</p>
          </div>
        </el-form-item>
        <el-form-item label="期刊支持:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.journalSupport }}</label>
        </el-form-item>
        <el-form-item label="期刊支持（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.journalSupportEn }}</label>
        </el-form-item>
        <el-form-item label="会议费用:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.conferenceExpenses }}</label>
        </el-form-item>
        <el-form-item label="会议费用（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.conferenceExpensesEn }}</label>
        </el-form-item>
        <el-form-item label="会议网站:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.conferenceWebsite }}</label>
        </el-form-item>
        <el-form-item label="会议网站（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.conferenceWebsiteEn }}</label>
        </el-form-item>
        <el-form-item label="联系方式:" v-show="meetingForm.languageType == LanguageTypeEnum.zh || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.contactInformation }}</label>
        </el-form-item>
        <el-form-item label="联系方式（英文）:" v-show="meetingForm.languageType == LanguageTypeEnum.en || meetingForm.languageType == LanguageTypeEnum.zhen">
          <label>{{ meetingForm.contactInformationEn }}</label>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleEdit()">编辑</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import commonTitle from "@/components/common/commonTitle";
export default {
  data() {
    return {
      meetingForm: {},
      code:'',
    };
  },
  components: {
    commonTitle,
  },
  created(){
    this.code = this.$route.query.code;
    this.getMeetingDetail();
  },
  computed:{
    currentMeetingCode(){
      return this.$store.state.dict.currentMeetingCode;
    }
  },
  watch:{
    currentMeetingCode(){
      this.code = this.currentMeetingCode;
      this.getMeetingDetail();
    }
  },
  methods: {
    getMeetingDetail() {
      const data = {
        meetingCode: this.code,
      };
      this.$api.getMeetingDetail(data).then((res) => {
        if (res.code == 200) {
          this.meetingForm = res.data;
        }
      });
    },
    handleEdit() {
      this.$router.push({
        path: "/editMeeting",
        query: {
          type: 2,
          code: this.code,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.outdiv {
  width: 800px;
  .el-form-item {
    margin-bottom: 5px;
  }
}
.tagMaxHeight{
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #a5b4bf54;
}
</style>
